import { useNavigate } from "react-router-dom";
import { ArrowLeft, MapPin, Calendar } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_fitsmith-academy/artifacts/zbh0gz3y_291E0B11-36FD-4420-BAF1-DDEC0FEFC105.png";

export default function OverOnsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#080808]">
      {/* Header */}
      <div className="border-b border-white/5 px-4 py-4">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <button onClick={() => navigate(-1)}
            className="w-8 h-8 rounded-xl bg-[#141414] border border-white/6 flex items-center justify-center text-zinc-400 hover:text-white transition-colors">
            <ArrowLeft size={16} />
          </button>
          <div className="flex items-center gap-2">
            <img src={LOGO_URL} alt="FitSmith" className="h-7 w-7 object-contain" />
            <span className="text-white font-bold tracking-wide">FitSmith</span>
          </div>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-16">
        {/* Intro */}
        <div className="mb-10">
          <p className="text-[#C9A84C] text-xs font-bold uppercase tracking-widest mb-3">Het verhaal achter FitSmith</p>
          <h1 className="text-white font-bold text-4xl mb-6">Over Ons</h1>
          <div className="w-16 h-1 rounded-full bg-[#C9A84C] mb-8" />
        </div>

        {/* Founder card */}
        <div className="bg-[#111] border border-white/8 rounded-2xl p-8 mb-10">
          <div className="flex items-start gap-5">
            <div className="w-16 h-16 rounded-2xl bg-[#C9A84C]/15 border border-[#C9A84C]/30 flex items-center justify-center shrink-0">
              <span className="text-[#C9A84C] font-black text-2xl">S</span>
            </div>
            <div>
              <h2 className="text-white font-bold text-xl mb-1">Sam van Grondelle</h2>
              <p className="text-[#C9A84C] text-sm font-semibold mb-3">Oprichter &amp; Coach · FitSmith</p>
              <div className="flex flex-wrap gap-3">
                <span className="flex items-center gap-1.5 text-zinc-500 text-xs">
                  <Calendar size={12} /> 23 jaar
                </span>
                <span className="flex items-center gap-1.5 text-zinc-500 text-xs">
                  <MapPin size={12} /> Aalsmeer
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Verhaal */}
        <div className="space-y-6 text-zinc-400 text-base leading-relaxed">
          <p>
            Al meer dan zeven jaar ben ik actief in de sportschool, een plek waar voor mij alles begon.
            Wat ooit startte als een persoonlijke uitdaging, groeide al snel uit tot een diepe passie:
            het begrijpen van het lichaam, het verbeteren van prestaties en vooral het helpen van anderen
            om het beste uit zichzelf te halen.
          </p>
          <p>
            In die jaren heb ik niet alleen mezelf ontwikkeld, maar ook gezien waar het voor veel mensen
            misgaat. Gebrek aan structuur, geen duidelijk plan, te veel informatie of juist verkeerde
            begeleiding. Ik merkte dat veel mensen gemotiveerd beginnen, maar onderweg afhaken omdat ze
            simpelweg niet weten wat ze moeten doen — of waarom ze het doen.
          </p>

          <div className="border-l-2 border-[#C9A84C]/40 pl-5 py-1">
            <p className="text-white/80 italic">
              "Daar is het idee voor deze website ontstaan."
            </p>
          </div>

          <p>
            Ik wilde een plek creëren waar alles samenkomt: duidelijkheid, structuur en resultaat.
            Een platform dat niet alleen voor ervaren sporters is, maar juist ook voor beginnende
            trainers, stagiaires en iedereen die serieus aan de slag wil met zijn of haar ontwikkeling.
            Geen onnodige poespas, maar praktische schema's, duidelijke uitleg en een systeem dat werkt.
          </p>
          <p>
            Mijn doel is simpel: mensen beter maken. Sterker, fitter en zelfverzekerder — zowel fysiek
            als mentaal. Ik geloof dat iedereen progressie kan boeken, mits je de juiste tools en
            begeleiding hebt. En precies dat is wat ik met deze website wil bieden.
          </p>
          <p>
            Alles wat je hier vindt, is gebaseerd op mijn eigen ervaring, kennis en de lessen die ik
            de afgelopen jaren heb geleerd. Dit is niet zomaar een website, maar iets waar ik mijn
            volledige passie in heb gestoken.
          </p>

          <div className="pt-4">
            <p className="text-white font-semibold text-lg">Want uiteindelijk gaat het niet alleen om trainen.</p>
            <p className="text-[#C9A84C] font-bold text-xl mt-1">Het gaat om groeien.</p>
          </div>

          <div className="pt-2">
            <p className="text-zinc-500 text-sm italic">— Sam van Grondelle, oprichter FitSmith</p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 text-center">
          <p className="text-zinc-600 text-xs">© 2026 FitSmith. Alle rechten voorbehouden.</p>
        </div>
      </div>
    </div>
  );
}
